import React from 'react';
import './MobileCard.css';

function MobileCard({ columns, data, renderCell, selected, onSelect, actions, primaryField = 'name' }) {
  const primaryCol = columns.find(c => c.key === primaryField) || columns[0];
  const otherCols = columns.filter(c => c.key !== primaryField);

  return (
    <div className={`mobile-card ${selected ? 'mobile-card--selected' : ''}`}>
      <div className="mobile-card-header">
        {onSelect && (
          <input
            type="checkbox"
            checked={selected}
            onChange={onSelect}
            className="mobile-card-checkbox"
          />
        )}
        <div className="mobile-card-title">
          {primaryCol && renderCell(primaryCol, data)}
        </div>
        {actions}
      </div>
      <div className="mobile-card-body">
        {otherCols.map(col => (
          <div key={col.key} className="mobile-card-field">
            <span className="mobile-card-label">{col.label}</span>
            <span className="mobile-card-value">{renderCell(col, data)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MobileCard;
